<ul>
  @for (menuLink of menuLinks; track menuLink.href || menuLink.text || $index; let i = $index) {
    <li
      [class.opened]="i === currentlyOpenedLinkIndex"
      [class.active]="isLinkActive(menuLink)"
      >
      @if (menuLink.href) {
        <a
          [routerLink]="menuLink.href"
          class="menu-link"
          data-bs-dismiss="offcanvas"
          >
          <div class="btn-container">
            @if (!menuLink.iconLeft) {
              <span class="bullet bullet-dot"></span>
            }
            @if (menuLink.iconLeft) {
              <fa-icon
                [icon]="menuLink.iconLeft"
                class="icon-start"
              ></fa-icon>
            }
            <span class="menu-link-text">{{ menuLink.text | translate }}</span>
            @if (menuLink.iconRight && !menuLink.children?.length) {
              <fa-icon
                [icon]="menuLink.iconRight"
                class="icon-end"
              ></fa-icon>
            }
          </div>
          @if (menuLink.children?.length) {
            <fa-icon
              [icon]="faChevronRight"
              class="icon-end"
            ></fa-icon>
          }
        </a>
      }
      @if (!menuLink.href) {
        <button type="button" (click)="openMenuLink(i)" class="menu-link">
          <div class="btn-container">
            @if (!menuLink.iconLeft) {
              <span class="bullet bullet-dot"></span>
            }
            @if (menuLink.iconLeft) {
              <fa-icon
                [icon]="menuLink.iconLeft"
                class="icon-start"
              ></fa-icon>
            }
            <span class="menu-link-text">{{ menuLink.text | translate }}</span>
            @if (menuLink.iconRight && !menuLink.children?.length) {
              <fa-icon
                [icon]="menuLink.iconRight"
                class="icon-end"
              ></fa-icon>
            }
          </div>
          @if (menuLink.children?.length) {
            <fa-icon
              [icon]="faChevronRight"
              class="icon-end"
            ></fa-icon>
          }
        </button>
      }
      @if (menuLink.children?.length) {
        <div
          class="collapse"
          [class.show]="i === currentlyOpenedLinkIndex"
          >
          <div class="menu-sublinks">
            <app-sidebar-menu [menuLinks]="menuLink.children || []"></app-sidebar-menu>
          </div>
        </div>
      }
    </li>
  }
</ul>
